/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuInputRangeDimensions_itemSearch$ref = any;
export type SbRespRefineMenuFilterDimensions_itemSearch$ref = any;
export type SbRespRefineMenuFilterDimensions_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuInputRangeDimensions_itemSearch$ref;
    readonly " $refType": SbRespRefineMenuFilterDimensions_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuFilterDimensions_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuInputRangeDimensions_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '5e1268eefe3c5705cbcbd04f966defe2';
export default node;
